export class Allocation {
    static blank() {
        return new this({});
    }

    constructor(json) {
        Object.assign(this, json);
    }

    static fromServer(json) {
        return new Allocation({
            projectId: json.id,
            cloudId: json.dataId,
            cloudIp: json.ip,
            account: 'root',
            password: decodeURIComponent(escape(atob(json.password))),
            dbaVersion: 'DM 8.1',
            port: json.dbPort,
            saAccount: json.dbUser,
            saPwd: decodeURIComponent(escape(atob(json.dbPassword))),
        });
    }

    toServer() {
        return {
            id: this.projectId,
            ip: this.cloudIp,
            username: this.account,
            password: btoa(unescape(encodeURIComponent(this.password))),
            dbaVersion: this.dbaVersion,
            dbPort: this.port,
            dbUser: this.saAccount,
            dbPassword: btoa(unescape(encodeURIComponent(this.saPwd))),
        };
    }

    cloudId = ''; //资源分配id
    cloudIp = "";
    account = "root";
    password = "";
    dbaVersion = "DM 8.1";
    hashPassword= '******';
    hashSaPwd = '******';
    showPassword = false;
    showSaPwd = false;
    port = "";
    saAccount = "";
    saPwd = "";
    type = "";
}